/// <reference path="wpt.ts" />
/// <reference path="documentActions/docActionAddToEnvelope.ts" />
/// <reference path="documentActions/docActionAddToFavourites.ts" />
/// <reference path="documentActions/docActionCreateNote.ts" />
/// <reference path="documentActions/docActionDeleteDocument.ts" />
/// <reference path="documentActions/docActionDownload.ts" />
/// <reference path="documentActions/docActionPrint.ts" />
/// <reference path="documentActions/docActionPseudoSysTask.ts" />
/// <reference path="documentActions/docActionReviseDocument.ts" />
/// <reference path="documentActions/docActionUploadRelated.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    let DocActions;
    (function (DocActions) {
        DocActions.DELETE_DOC = "DeleteDocument";
        DocActions.DOWNLOAD = "Download";
        DocActions.PRINT = "Print";
        DocActions.PSEUDO_SYS_TASK = "PseudoSystemTasks";
        DocActions.REVISE_DOC = "ReviseDocument";
        DocActions.UPLOAD_RELATED = "UploadRelated";
        DocActions.CREATE_NOTE = "CreateNote";
        const LOG_CATEGORY = "WPT.DocumentActions";
        // I think we can just use an array here, and pull the rest of the data on instantiation
        const STANDARD_DOCACTIONS = [
            {
                Name: "AddToEnvelope",
                Class: "WPTNamespace.DocActions.DocActionAddToEnvelope"
            },
            {
                Name: "AddToFavourites",
                Class: "WPTNamespace.DocActions.DocActionAddToFavourites"
            },
            {
                Name: DocActions.CREATE_NOTE,
                Class: "WPTNamespace.DocActions.DocActionCreateNote"
            },
            {
                Name: DocActions.DELETE_DOC,
                Class: "WPTNamespace.DocActions.DocActionDeleteDocument"
            },
            {
                Name: DocActions.DOWNLOAD,
                Class: "WPTNamespace.DocActions.DocActionDownload"
            },
            {
                Name: DocActions.PRINT,
                Class: "WPTNamespace.DocActions.DocActionPrint"
            },
            {
                Name: DocActions.PSEUDO_SYS_TASK,
                Class: "WPTNamespace.DocActions.DocActionPseudoSysTask"
            },
            {
                Name: DocActions.REVISE_DOC,
                Class: "WPTNamespace.DocActions.DocActionReviseDocument"
            },
            {
                Name: DocActions.UPLOAD_RELATED,
                Class: "WPTNamespace.DocActions.DocActionUploadRelated"
            }
        ];
        // Action requests
        class DocActionRequest {
            // Force construction with handle
            constructor(handle) {
                this.Document = null;
                this.DocumentType = null;
                this.DocumentData = null;
                this.PropertyBag = {};
                this.Filter = ['*'];
                this.DocHandle = handle;
            }
        }
        DocActions.DocActionRequest = DocActionRequest;
        /**
         * Context information to look at for checking if an action is allowed.
         */
        class DocActionAllowedRequest {
            constructor() {
                this.DocumentType = null;
                this.PropertyBag = [];
            }
        }
        DocActions.DocActionAllowedRequest = DocActionAllowedRequest;
        class DocActionBaseClass {
            constructor(core, name, config = {}) {
                // General metadata
                this._core = null;
                this._log = null;
                this._name = null;
                this._label = null;
                // Initialisation handling
                this._readyToExecute = false;
                this._pendingRequest = null;
                this._core = core;
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DocActionBaseClass::constructor");
                this._name = name;
            }
            get Name() {
                this._log.info("DocActionBaseClass.Name()");
                return this._name;
            }
            get Label() {
                this._log.info("DocActionBaseClass.Label()");
                return this._label;
            }
            // Returns true if no permissions available, otherwise false
            // Children NEED to override to filter further on exact permissions
            actionAllowed(request) {
                this._log.info("DocActionBaseClass.actionAllowed()");
                // Basic functions here, needs to be called as super then values filtered further
                if (!request || !request.DocumentType || !request.DocumentType.hasOwnProperty('Privileges') || !request.DocumentType.Privileges)
                    return true;
                else
                    return false;
            }
            /**
             * Checks whether direct execution of the DocumentAction is needed. Default is FALSE.
             *
             * @param request request for planned DocumentAction execution
             */
            needsDirectExecution(request) {
                this._log.info("DocActionBaseClass.needsDirectExecution()");
                return false;
            }
            // Universal execute method - needs to be overridden
            execute(request) {
                this._log.info("DocActionBaseClass.execute()");
                request.Result = 'Cancelled';
            }
        }
        DocActions.DocActionBaseClass = DocActionBaseClass;
        // Manager class for all document actions to be generated
        class DocActionManager {
            constructor(core) {
                // Core metadata
                this._core = null;
                this._log = null;
                this._custConfig = {};
                this._suppressList = [];
                // UI/Modal support
                this._modalSkeleton = null;
                // Action management
                this._actionLabels = []; // This might be useless with no mapping to name - probably remove
                this._actions = {};
                // State
                this._currentRequest = null;
                this._selectedAction = null;
                this._currentSelectionModalSession = null;
                this._storeModalSkeleton = (htmlData) => {
                    this._log.info("DocActionManager._storeModalSkeleton()");
                    this._modalSkeleton = htmlData;
                };
                this.init = () => {
                    this._log.info("DocActionManager.init()");
                    // Reload and tidy configuration from application config
                    let appConf = this._core.Config.getApplicationConfig();
                    if (appConf.hasOwnProperty('SuppressDocumentActions') && appConf.SuppressDocumentActions)
                        this._suppressList = appConf.SuppressDocumentActions;
                    else
                        this._suppressList = [];
                    let includeSystemTasks = this._loadActions();
                    // Load custom actions if we have them
                    this._custConfig = {};
                    if (appConf.hasOwnProperty('Custom') && (appConf.Custom != null)) {
                        let custConfig = appConf.Custom;
                        if (custConfig.hasOwnProperty('UseCustomObjects') && (custConfig.UseCustomObjects != null) && custConfig.UseCustomObjects) {
                            if (custConfig.hasOwnProperty('CustomDocActions') && (custConfig.CustomDocActions != null)) {
                                this._custConfig = custConfig.CustomDocActions;
                                this._loadCustomActions();
                            }
                        }
                    }
                    // Run after the main and custom stuff to keep system tasks together
                    if (includeSystemTasks) {
                        this._core.OBHelper.LoadPseudoSystemTasks(this._loadPseudoSystemTasks);
                    }
                };
                // Load all built-in actions, and return a flag indicating if we want to include system tasks
                this._loadActions = () => {
                    this._log.info("DocActionManager._loadActions()");
                    // Reset
                    this._actionLabels = [];
                    this._actions = {};
                    // Loop with iterator for more control
                    let includeSystemTasks = false;
                    for (let i = 0; i < STANDARD_DOCACTIONS.length; i++) {
                        let docAction = STANDARD_DOCACTIONS[i];
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("looking at document action: " + docAction.Name);
                        }
                        if (this._suppressList.indexOf(docAction.Name) == -1) {
                            if (docAction.Name == DocActions.PSEUDO_SYS_TASK)
                                includeSystemTasks = true;
                            else {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace(`Locating document action constructor ${docAction.Class}`);
                                }
                                let actionConstructor = this._core.Functions.stringToFunction(docAction.Class);
                                let actionInstance = new actionConstructor(this._core, docAction.Name);
                                if (actionInstance) {
                                    this._actions[actionInstance.Name] = actionInstance;
                                    this._actionLabels.push[actionInstance.Label];
                                }
                                else {
                                    console.error(`Could not create instance of document action '${docAction.Name}'`);
                                }
                            }
                        }
                    }
                    return includeSystemTasks;
                };
                this._loadCustomActions = () => {
                    this._log.info("DocActionManager._loadCustomActions()");
                    if (Object.keys(this._custConfig).length == 0)
                        return;
                    for (let actionId in this._custConfig) {
                        let actionInfo = this._custConfig[actionId];
                        if ((this._suppressList.indexOf(actionId) == -1) && actionInfo.hasOwnProperty('File') && actionInfo.hasOwnProperty('Class')) {
                            this._core.Loader.loadUnversionedJS(actionInfo.File, this._createCustomAction.bind(this, actionId, actionInfo), this._customActionLoadFailed.bind(this, actionId));
                        }
                    }
                };
                this._createCustomAction = (actionId, actionInfo) => {
                    this._log.info("DocActionManager._createCustomAction()");
                    let conf = (actionInfo.hasOwnProperty('Config') && (actionInfo.Config != null)) ? actionInfo.Config : {};
                    try {
                        let actionConstructor = this._core.Functions.stringToFunction(actionInfo.Class);
                        let action = new actionConstructor(this._core, actionId, conf);
                        if (action) {
                            this._actions[action.Name] = action;
                            this._actionLabels.push[action.Label];
                        }
                        else {
                            console.error(`Could not create instance of document action '${actionId}'`);
                        }
                    }
                    catch (ex) {
                        console.warn("failed to create custom doc action '" + actionId + "' - " + ex.message);
                    }
                };
                this._customActionLoadFailed = (actionId) => {
                    this._log.info("DocActionManager._customActionLoadFailed()");
                    console.warn(`Failed to load script file for custom action with ID '${actionId}'`);
                };
                this._loadPseudoSystemTasks = () => {
                    this._log.info("DocActionManager._loadPseudoSystemTasks()");
                    let pstActionRecord = STANDARD_DOCACTIONS.find(ar => ar.Name == DocActions.PSEUDO_SYS_TASK);
                    if (!pstActionRecord) {
                        console.warn("Attempt to instantiate document actions for pseudo-system tasks failed - no class definition found.");
                        return;
                    }
                    let actionConstructor = this._core.Functions.stringToFunction(pstActionRecord.Class);
                    // Need an action for each PST
                    this._core.OBHelper.PseudoSystemTasks.forEach(pst => {
                        let actionInstance = new actionConstructor(this._core, DocActions.PSEUDO_SYS_TASK, pst.Identifier);
                        if (actionInstance) {
                            this._actions[actionInstance.Name] = actionInstance;
                            this._actionLabels.push[actionInstance.Label];
                        }
                        else {
                            console.error(`Could not create instance of document action '${DocActions.PSEUDO_SYS_TASK}' - '${pst.Identifier}'`);
                        }
                    });
                };
                this.getAllowedActions = (actionRequest, allowedRequest) => {
                    this._log.info("DocActionManager.getAllowedActions()");
                    let result = [];
                    // Store state. Null an undefined document type so we can check against it
                    if (!actionRequest.hasOwnProperty('DocumentType'))
                        actionRequest.DocumentType = null;
                    if (!actionRequest.Filter || (actionRequest.Filter.length < 1))
                        actionRequest.Filter = ["*"];
                    for (let actionName in this._actions) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace(`checking action '${actionName}'`);
                        }
                        let action = this._actions[actionName];
                        if (((actionRequest.Filter.indexOf('*') > -1) || (actionRequest.Filter.indexOf(action.Name) > -1)) && (action.actionAllowed(allowedRequest))) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`action '${actionName}' allowed`);
                            }
                            result.push(action);
                        }
                    }
                    return result;
                };
                // Shows menu of actions to allow selection
                this.displayActionMenu = (actionRequest, allowedRequest) => {
                    this._log.info("DocActionManager.displayActionMenu()");
                    // If we have no skeleton, something went wrong because we should have that from startup
                    if (!this._modalSkeleton)
                        return;
                    // Load the modal
                    let modalSession = 'docaction-selection-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modal = this._core.requestModal(WPTNamespace.ModalType.FIRST, modalSession);
                    if (modal !== null && modal !== undefined) {
                        this._currentSelectionModalSession = modalSession;
                        modal.DIV.innerHTML = this._modalSkeleton;
                        // Sort the overall content
                        let componentContainer = modal.DIV.querySelector('#damComponentContainer');
                        this._core.Helper.setElementTranslation(modal.DIV.querySelector('#daSelectHeading'), 'STR_WPT_DA_SELECT');
                        let cancelTranslation = this._core.Locale.getTranslation('STR_WPT_CANCEL');
                        modal.DIV.querySelector('#daSelectCloseButtonLabel').innerHTML = cancelTranslation;
                        modal.DIV.querySelector('#closeIcon').setAttribute('title', cancelTranslation);
                        modal.DIV.querySelector('#closeIcon').setAttribute('aria-label', cancelTranslation);
                        // Generate the component
                        let bpConfig = {
                            UsePrimaryColour: false
                        };
                        let bpComponent = new WPTNamespace.Widgets.ComponentButtonPalette(this._core, componentContainer, null, bpConfig, this._actionSelected);
                        bpComponent.present();
                        let allowedActions = this.getAllowedActions(actionRequest, allowedRequest);
                        this._currentRequest = actionRequest;
                        this._selectedAction = null;
                        let options = [];
                        allowedActions.forEach(action => {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`inserting action '${action.Name}'`);
                            }
                            let option = { Identifier: action.Name, Label: action.Label, Hidden: false, Group: "Document Actions" };
                            if (action.Name.startsWith(DocActions.PSEUDO_SYS_TASK + ":")) {
                                let sysTaskName = action.Name.substring((DocActions.PSEUDO_SYS_TASK + ":").length);
                                option.Icon = this._core.Helper.getButtonIcon({
                                    Type: "SysTask",
                                    Name: sysTaskName
                                });
                            }
                            else {
                                option.Icon = this._core.Helper.getButtonIcon({
                                    Type: "DocAction",
                                    Name: action.Name
                                });
                            }
                            options.push(option);
                        }, this);
                        bpComponent.displayOptions(options, this._actionsDisplayed);
                    }
                    else {
                        console.error("unable to show doc action selection modal, modal placeholder is already used");
                    }
                };
                this._actionsDisplayed = (count) => {
                    this._log.info("DocActionManager._actionsDisplayed()");
                    if (count > 0) {
                        this._core.showModal(this._currentSelectionModalSession);
                    }
                    else {
                        let modal = this._core.getModal(this._currentSelectionModalSession);
                        if (modal) {
                            modal.DIV.innerHTML = '';
                            this._core.returnModal(this._currentSelectionModalSession);
                            this._currentSelectionModalSession = null;
                        }
                    }
                };
                // private _actionSelected = (actionName: string, request: DocActionRequest) => {
                this._actionSelected = (actionName) => {
                    this._log.info("DocActionManager._actionSelected()");
                    let action = this._actions[actionName];
                    this._selectedAction = actionName;
                    if (action && action.needsDirectExecution(this._currentRequest)) {
                        // use second modal for direct execution to avoid modal clash
                        this._currentRequest.PropertyBag.ModalTypeToUse = WPTNamespace.ModalType.SECOND;
                        this.execute(this._selectedAction, this._currentRequest);
                    }
                    else {
                        // Hide and clear down our modal before execution in case the action needs a modal
                        let modal = this._core.getModal(this._currentSelectionModalSession);
                        modal.JQ.one('hidden.bs.modal', this._selectDialogClosed);
                    }
                    this._core.hideModal(this._currentSelectionModalSession);
                    this._currentSelectionModalSession = null;
                };
                this._selectDialogClosed = () => {
                    this._log.info("DocActionManager._selectDialogClosed()");
                    if (this._selectedAction) {
                        this.execute(this._selectedAction, this._currentRequest);
                    }
                    this._selectedAction = null;
                    this._currentRequest = null;
                };
                this._core = core;
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DocActionManager::constructor");
                core.Loader.getVersionedHTML('widgets/documentactions/menumodal.html', this._storeModalSkeleton, this._core.Helper.missingHtmlErrorCallback);
                this.init();
            }
            get ActionLabels() {
                this._log.info("DocActionManager.ActionLabels()");
                return this._actionLabels;
            }
            get Actions() {
                this._log.info("DocActionManager.Actions()");
                return this._actions;
            }
            /**
             * Checks whether direct execution of the DocumentAction is needed. Default is FALSE.
             *
             * @param name name of the DocumentAction
             * @param request request for DocumentAction execution
             */
            needsDirectExecution(name, request) {
                this._log.info("DocActionManager.needsDirectExecution()");
                if (name in this._actions)
                    return this._actions[name].needsDirectExecution(request);
                return false;
            }
            // Not sure if we need to proxy execution, but for now
            execute(name, request) {
                this._log.info("DocActionManager.execute()");
                if (name in this._actions)
                    this._actions[name].execute(request);
            }
        }
        DocActions.DocActionManager = DocActionManager;
    })(DocActions = WPTNamespace.DocActions || (WPTNamespace.DocActions = {}));
})(WPTNamespace || (WPTNamespace = {}));
